<template>
  <section class="menu-items weiby-container">
    <div
      v-for="category in items"
      :key="`menu-category-${category.index}`"
      :id="`menu-category-${category.index}`"
      :data-toc-idx="category.index"
      class="last:mb-0 mb-10"
    >
      <h2 class="mb-4 text-primary-500 text-xl">
        {{ category.name }}
      </h2>
      <div class="menu-items__items">
        <div
          v-for="entree in sortEntrees(category.entrees)"
          :key="`menu-entree-${entree.index}`"
          :class="{ 'pr-4': entree.photo }"
          class="menu-items__item relative"
          @click="$emit('click', entree.index)"
        >
          <div
            v-if="hasItemLimit(entree.index) && itemAvailable(entree.index) === 0"
            class="
              absolute
              bg-light-gray-500
              opacity-90
              w-full
              h-full
              flex
              items-center
              justify-center
            "
          >
            訂購已達上限
          </div>
          <div class="flex flex-col flex-grow flex-shrink justify-between w-[calc(100%-117px)]">
            <div
              :class="[
                itemCount(entree.index) ?
                  'pb-2 pr-4 pt-1.5 rounded-t sm:pt-0' :
                  'px-4 py-2 rounded-t sm:px-4 sm:py-1'
              ]"
              class="text-lg text-black truncate"
            >
              <span
                v-if="itemCount(entree.index)"
                class="
                  bg-primary-500
                  mr-2
                  px-2
                  py-3
                  rounded-br
                  rounded-tl
                  text-center
                  text-white
                "
              >{{ itemCount(entree.index) }}</span>
              <label
                :title="entree.name"
                class="cursor-pointer"
              >
                {{ entree.name }}
              </label>
            </div>
            <div class="pb-1 pt-1 px-4 text-sm text-gray-500">
              <p class="line-clamp-2">
                {{ entree.storeNote }}
              </p>
            </div>

            <div class="flex justify-between items-end pb-2 px-4 rounded-b text-black">
              <p>{{ entree.price | commaFormat | priceFormat }}</p>
              <p v-if="hasItemLimit(entree.index)" class="text-sm text-gray-500">
                可訂購數： {{ itemAvailable(entree.index) }}
              </p>
            </div>
          </div>
          <div
            v-if="entree.photo"
            class="flex-grow-0 flex-shrink-0 h-[117px] self-center w-[117px]"
          >
            <img
              :alt="`Entree photo - ${entree.name}`"
              :src="entree.photo"
              :title="entree.name"
              class="h-full w-full"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import MenuItems from './MenuItems';

export default MenuItems;
</script>

<style lang="scss" scoped>
@import 'MenuItems';
</style>
